
export const footerTranslations = {
  about: {
    fr: "À propos",
    en: "About"
  },
  contact: {
    fr: "hello@firsttuesday.dz",
    en: "hello@firsttuesday.dz"
  },
  rights: {
    fr: "Tous droits réservés.",
    en: "All rights reserved."
  },
  legal: {
    fr: "Mentions légales",
    en: "Legal mentions"
  },
  privacy: {
    fr: "Politique de confidentialité",
    en: "Privacy policy"
  }
};
